import { useMemo } from "react";
import { useLang } from "@/context/LanguageContext";
import { ui } from "@/i18n/strings";
import * as siteTR from "@/data/site";
import * as siteEN from "@/data/site_en";
import { projects as projectsTR } from "@/data/projects";
import { projectsEn } from "@/data/projects_en";

function interpolate(value, vars) {
  if (typeof value !== "string" || !vars) return value;
  return value.replace(/\{(\w+)\}/g, (_, k) =>
    vars[k] !== undefined && vars[k] !== null ? String(vars[k]) : `{${k}}`
  );
}

// UI micro-string translator: t("nav.home"), t("home.heroPara", { since: 1993 })
export function useT() {
  const { lang } = useLang();
  return (key, vars) => {
    const table = ui[lang] || ui.tr;
    const value = table[key] !== undefined ? table[key] : ui.tr[key];
    if (value === undefined) return key;
    return interpolate(value, vars);
  };
}

// Content bundle (vision, mission, services, certificates, categories...).
export function useContent() {
  const { lang } = useLang();
  return lang === "en" ? siteEN : siteTR;
}

export function useCategoryName() {
  const content = useContent();
  return (slug) =>
    (content.categories.find((c) => c.slug === slug) || {}).name || slug;
}

// Projects localized for the active language (name / scope / location).
export function useProjects() {
  const { lang } = useLang();
  return useMemo(() => {
    if (lang !== "en") {
      return {
        projects: projectsTR,
        featuredProjects: projectsTR
          .filter((p) => p.featured > 0)
          .sort((a, b) => a.featured - b.featured),
        getProject: (s) => projectsTR.find((p) => p.slug === s),
      };
    }
    const localized = projectsTR.map((p) => {
      const o = projectsEn[p.slug];
      return o ? { ...p, name: o.name, is: o.is, location: o.location } : p;
    });
    return {
      projects: localized,
      featuredProjects: localized
        .filter((p) => p.featured > 0)
        .sort((a, b) => a.featured - b.featured),
      getProject: (s) => localized.find((p) => p.slug === s),
    };
  }, [lang]);
}
